








import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class MaskLayer extends Vue {
  /* -------------- prop ------------- */
  @Prop({ default: false }) maskActive?: boolean; // 遮罩显示状态
  @Prop(String) scrollWrap?: string; // 可滚动容器类名
  @Prop({ default: "transparent" }) layerColor?: string; // layer背景颜色

  /* -------------- watch ------------- */
  @Watch("maskActive")
  onChangeMaskActive (val: boolean) {
    if (val) {
      // 隐藏页面滚动条
      const m = window.innerWidth - document.body.clientWidth; // 滚动条的宽度
      document.documentElement.style.marginRight = m + "px";
      document.documentElement.style.overflowY = "hidden";
    } else {
      // 显示页面滚动条
      document.documentElement.style.marginRight = "0px";
      document.documentElement.style.overflowY = "auto";
    }
  }
}
